<template>
  <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mx-4 mt-5">
    <div class="bg-white dark:bg-slate-800 p-4 rounded-md">
      <div
        class="p-2 bg-gray-50 dark:bg-gray-700 text-slate-500 dark:text-slate-100"
      >
        <div class="text-lg mb-1">
          {{ $t('BROADCAST.STATS.TOTAL_MESSAGE') }}
        </div>
        <div class="space-y-1">
          <h3 class="text-slate-500 dark:text-slate-100">
            {{ totalCount }}
          </h3>
        </div>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 p-4 rounded-md">
      <div
        class="p-2 bg-gray-50 dark:bg-gray-700 text-slate-500 dark:text-slate-100"
      >
        <div class="text-lg mb-1">
          {{ $t('BROADCAST.STATS.TOTAL_PENDING') }}
        </div>
        <div class="space-y-1">
          <h3 class="text-slate-500 dark:text-slate-100">
            {{ pendingCount }}
          </h3>
        </div>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 p-4 rounded-md">
      <div
        class="p-2 bg-gray-50 dark:bg-gray-700 text-slate-500 dark:text-slate-100"
      >
        <div class="text-lg mb-1">
          {{ $t('BROADCAST.STATS.TOTAL_APPROVED') }}
        </div>
        <div class="space-y-1">
          <h3 class="text-slate-500 dark:text-slate-100">
            {{ approvedCount }}
          </h3>
        </div>
      </div>
    </div>

    <div class="bg-white dark:bg-slate-800 p-4 rounded-md">
      <div
        class="p-2 bg-gray-50 dark:bg-gray-700 text-slate-500 dark:text-slate-100"
      >
        <div class="text-lg mb-1">
          {{ $t('BROADCAST.STATS.SUCCESS_RATE') }}
        </div>
        <div class="space-y-1">
          <h3 class="text-slate-500 dark:text-slate-100">
            {{ deliveryStats.success_rate || 0 }}%
          </h3>
          <div class="text-xs">
            {{
              $t('BROADCAST.STATS.SUCCESS_DETAIL', {
                delivered: deliveryStats.delivered_count || 0,
                sent: deliveryStats.sent_count || 0,
                failed: deliveryStats.failed_count || 0,
              })
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
    pendingCount: {
      type: Number,
      default: 0,
    },
    approvedCount: {
      type: Number,
      default: 0,
    },
    deliveryStats: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
